import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";

export class usersMultiSelectCtrl implements IController {

  selectedIds: any;
  ngPlaceholder: any;
  isDisabled: any;
  onChange: Function;

  public selectedText: any;

  /* @ngInject */
  constructor(private $mdPanel, private $element) {
  }

  $onInit() {
    this._setSelectedText();
  };

  $onChanges(changes) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()){
      this._setSelectedText();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdsRef = this.selectedIds || [];

    const ngPlaceholderRef = this.ngPlaceholder;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-multi-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-ids="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'query-map="ctrl.queryMapRef" ' +
        'service-areas-types="ctrl.serviceTypesRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-multi-select-filter-panel>',
      controller: function () {
        this.typeRef = 'users';
        this.selectedIdsRef = selectedIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
        this.queryMapRef = {};
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedIds) => {
        if (selectedIds === 'clickOutsideToClose' || selectedIds === 'escapeToClose') {
          selectedIds = selectedIdsRef;
        }

        this.onChange({ids: selectedIds});
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({ids: []});
  }

  private _setSelectedText() {
    let string = '';
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext("2d");

    _.forEach(this.selectedIds, (user, i) => {
      string += user;
      if ((i + 1) < this.selectedIds.length) {
        string += ', '
      }
    });

    var stringWidth = ctx.measureText(string).width;
    if (this.$element[0]?.clientWidth && (stringWidth + 80) >= (this.$element[0].clientWidth - 30)) {
      string = this.selectedIds[0] + ` +${this.selectedIds.length - 1}`
    }
    this.selectedText = string;
  }


}

angular
  .module('bringoz.admin.site-preferences')
  .component('usersMultiSelect', {
    bindings: {
      selectedIds: '<',
      ngPlaceholder: '@?',
      isDisabled: '<?',
      onChange: '&'
    },
    template: require('./users-multi-select.html').default,
    controller: usersMultiSelectCtrl
  });
